<div class="order__wrapper" test-target="order__wrapper">
    <div class="order__heading">
        <h3 class="order__title" [mmTestTarget]="'order-title'">
            {{order?.orderNumber}}
            {{ 'PAGES.ACCOUNT.ORDERS_HISTORY.ORDER_ORDERED_ON' | translate }}
            {{order?.createdAt | date: 'MMM d, yyyy'}}
        </h3>
        <div class="order__actions-bar">
            <ng-container *ngIf="!isMobileOrTablet">
                <ng-container *ngTemplateOutlet="actionButtons"></ng-container>
            </ng-container>

            <button *ngIf="shouldShowContextualMenu" mm-button [color]="'secondary'" [size]="'small'"
                [iconButton]="true" class="order__action-btn" [mmTestTarget]="'order-detail-actions-more-menu'"
                mmContextualMenu [mmContent]="contentTemplate" [mmTrigger]="menuTrigger.hover" mmPlacement="bottomRight"
                type="button">
                <mm-icon name="dot-three-horizontal"></mm-icon>
            </button>
        </div>
    </div>

    <ng-container *ngIf="isMobileOrTablet">
        <ng-container *ngTemplateOutlet="actionButtons; context: { fluid: true }"></ng-container>
    </ng-container>


    <ng-template #contentTemplate>
        <mm-contextual-menu-item *ngIf="isAllowedCancelOrder" color="warning" [mmTestTarget]="'cancel-order'"
            (click)="cancelOrder()">
            {{ 'PAGES.ACCOUNT.ORDERS_HISTORY.BUTTON_CANCEL_ORDER' | translate }}
        </mm-contextual-menu-item>
        <ng-container *ngIf="isAllowedReturnOrder">
            <div [mmTooltip]="returnTooltipContent" [mmTooltipDisabled]="isOrderReturnableByDays">
                <mm-contextual-menu-item color="warning" [disabled]="!isOrderReturnableByDays"
                    [mmTestTarget]="'return-order'" (click)="returnOrder()">
                    {{ 'PAGES.ACCOUNT.ORDERS_HISTORY.BUTTON_RETURN_ORDER' | translate }}
                </mm-contextual-menu-item>
            </div>
        </ng-container>
        <ng-template #returnTooltipContent>
            <p class="order__tooltip">
                {{ 'PAGES.ACCOUNT.ORDERS_HISTORY.BUTTON_RETURN_PRODUCT_TOOLTIP' | translate }}
            </p>
        </ng-template>
        <mm-contextual-menu-item color="warning" [mmTestTarget]="'cancel-return-order'"
            *ngIf="isAllowedCancelReturningOrder" (click)="cancelReturnOrder()">
            {{ 'PAGES.ACCOUNT.ORDERS_HISTORY.BUTTON_CANCEL_RETURN_ORDER' | translate }}
        </mm-contextual-menu-item>
    </ng-template>

    <app-order-history-details [order]="order" [isFirstOrder]="isFirstOrder"
        [isEnabledPaymentMethodCode]="isEnabledPaymentMethodCode"
        (accordianClicked)="sendGAEventPaymentShiptment($event)"></app-order-history-details>

    <ng-container *ngFor="let orderLine of order?.orderLines; let isLast = last">
        <app-order-lines-item *ngIf="!orderLine.referenceLine" [orderLine]="orderLine" [orderId]="order?.orderId"
            [orderNumber]="order?.orderNumber" [orderCreationDate]="order?.createdAt"
            [isContactEmailFeatureEnabled]="isContactEmailFeatureEnabled"
            [isGetInvoiceFeatureEnabled]="isGetInvoiceFeatureEnabled"
            [isEntrepreneur]="order?.buyer?.type?.value === buyerType.entrepreneur"
            [isBuyAgainButtonEnable] = "isBuyAgainButtonEnable"
            [isSubsidiaryAccount]="isSubsidiaryAccount"
            [isMobileOrTablet]="isMobileOrTablet" [isLastOrderLine]="isLast">
        </app-order-lines-item>

        <app-order-line-vas-item  *ngIf="orderLine.referenceLine" [orderLine]="orderLine"
            [isEntrepreneur]="order?.buyer?.type?.value === buyerType.entrepreneur" [isLastOrderLine]="isLast">
        </app-order-line-vas-item>
    </ng-container>

    <div *ngIf="!isLastOrder" class="order__divider"></div>
</div>

<ng-template #invoiceTooltipContent>
    <p class="order__tooltip">
        {{ 'PAGES.ACCOUNT.ORDERS_HISTORY.BUTTON_DOWNLOAD_INVOICE_HINT' | translate }}
    </p>
</ng-template>

<ng-template #actionButtons let-fluid="fluid">
    <div *ngIf="isAllowedDownloadInvoicesDocs && !isSubsidiaryAccount" class="order__action-btn" [mmTooltip]="invoiceTooltipContent"
        [mmTooltipDisabled]="isInvoiceDocumentsAttached">
        <button mm-button [color]="'primary'" [disabled]="!isInvoiceDocumentsAttached" (click)="downloadInvoices()"
            [fluid]="fluid" [mmTestTarget]="'download-invoices'">
            {{ 'PAGES.ACCOUNT.ORDERS_HISTORY.BUTTON_DOWNLOAD_INVOICE' | translate }}
        </button>
    </div>
</ng-template>
